var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGitpodioIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.217 19.173L32.007 32v2.86h-.014v7.593h.014v8.678l16.637-9.53v-6.346L37.485 41.6v-6.414l16.746-9.532V44.84L32.007 57.56V64L59.71 48V16z",
    fill: "#0091ce"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.292 48l27.715 16v-6.44l-22.2-12.72V19.186L4.292 16zm27.715 3.132V32l-16.624-9.6-.014.014V41.6z",
    fill: "#0086bd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.708 16.014V16l-27.7-16L4.292 16l5.505 3.186 22.2-12.814 22.2 12.8L59.708 16zm-27.7-3.2L15.383 22.4 32.007 32l16.624-9.6z",
    fill: "#18a5e3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitpodioIcon);
export default __webpack_public_path__ + "static/media/gitpodio-icon.2c58afd672c747c8e74f0c4cd35d6359.svg";
export { ForwardRef as ReactComponent };